import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Button from '$lib/components/ui/button/button.svelte';

var root_4 = $.from_svg(`<svg class="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>`);
var root_3 = $.from_svg(`<!> `, 1);
var root_1 = $.from_html(`<div class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title" aria-describedby="confirm-dialog-description" tabindex="-1"><div class="bg-background rounded-lg shadow-lg w-full max-w-md p-6 animate-in fade-in zoom-in-95"><h2 id="confirm-dialog-title" class="text-lg font-semibold mb-2"> </h2> <p id="confirm-dialog-description" class="text-muted-foreground mb-6"> </p> <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-2"><!> <!></div></div></div>`);

export default function Confirm_dialog($$anchor, $$props) {
	$.push($$props, true);

	let confirmLabel = $.prop($$props, 'confirmLabel', 3, 'Confirm'),
		cancelLabel = $.prop($$props, 'cancelLabel', 3, 'Cancel'),
		isLoading = $.prop($$props, 'isLoading', 3, false);

	function handleBackdropClick(event) {
		if (event.target === event.currentTarget && !isLoading()) {
			$$props.onCancel();
		}
	}

	function handleKeydown(event) {
		if (event.key === 'Escape' && !isLoading()) {
			$$props.onCancel();
		}
	}

	var fragment = $.comment();

	$.event('keydown', $.window, handleKeydown);

	var node = $.first_child(fragment);

	{
		var consequent_1 = ($$anchor) => {
			var div = root_1();

			div.__click = handleBackdropClick;
			div.__keydown = (e) => e.key === 'Escape' && !isLoading() && $$props.onCancel();

			var div_1 = $.child(div);
			var h2 = $.child(div_1);
			var text = $.child(h2, true);

			$.reset(h2);

			var p = $.sibling(h2, 2);
			var text_1 = $.child(p, true);

			$.reset(p);

			var div_2 = $.sibling(p, 2);
			var node_1 = $.child(div_2);

			Button(node_1, {
				variant: 'outline',

				get onclick() {
					return $$props.onCancel;
				},

				get disabled() {
					return isLoading();
				},

				class: 'min-h-[44px] w-full sm:w-auto',

				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_2 = $.text();

					$.template_effect(() => $.set_text(text_2, cancelLabel()));
					$.append($$anchor, text_2);
				},

				$$slots: { default: true }
			});

			var node_2 = $.sibling(node_1, 2);

			Button(node_2, {
				variant: 'destructive',

				get onclick() {
					return $$props.onConfirm;
				},

				get disabled() {
					return isLoading();
				},

				class: 'min-h-[44px] w-full sm:w-auto',

				children: ($$anchor, $$slotProps) => {
					var fragment_2 = root_3();
					var node_3 = $.first_child(fragment_2);

					{
						var consequent = ($$anchor) => {
							var svg = root_4();

							$.append($$anchor, svg);
						};

						$.if(node_3, ($$render) => {
							if (isLoading()) $$render(consequent);
						});
					}

					var text_3 = $.sibling(node_3, 1, true);

					$.template_effect(() => $.set_text(text_3, confirmLabel()));
					$.append($$anchor, fragment_2);
				},

				$$slots: { default: true }
			});

			$.reset(div_2);
			$.reset(div_1);
			$.reset(div);

			$.template_effect(() => {
				$.set_text(text, $$props.title);
				$.set_text(text_1, $$props.description);
			});

			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($$props.open) $$render(consequent_1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

$.delegate(['click', 'keydown']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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